import { defineMessages, useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import imagesSVG from '@plone/volto/icons/images.svg';
import { resolveImageUrl } from '../../../helpers/blocks';
import PhotoMosaicSchema from './schema';
import PhotoMosaicView from './PhotoMosaicView';
import type { PhotoMosaicData } from './PhotoMosaicView';

const messages = defineMessages({
  placeholder: {
    id: 'photoMosaic.placeholder',
    defaultMessage: 'Select the block and add images in the sidebar',
  },
});

type PhotoMosaicEditProps = {
  data: PhotoMosaicData;
  block: string;
  selected: boolean;
  onChangeBlock: (block: string, data: PhotoMosaicData) => void;
};

const PhotoMosaicEdit = (props: PhotoMosaicEditProps) => {
  const { data, block, onChangeBlock, selected } = props;
  const intl = useIntl();
  const schema = PhotoMosaicSchema({ intl });

  const hasImages = (data.images || []).some((item) =>
    resolveImageUrl(item.image, 'large'),
  );

  return (
    <>
      {hasImages ? (
        <PhotoMosaicView data={data} />
      ) : (
        <div className="photo-mosaic-placeholder">
          <Icon name={imagesSVG} size="32px" />
          <p>{intl.formatMessage(messages.placeholder)}</p>
        </div>
      )}
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id: string, value: unknown) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default PhotoMosaicEdit;
